import Vue from "vue";

export const apiLoading = new Vue();